import { AlternativeOpenWebBuckets } from 'src/replicant/utils/payload';
import {
  createFlexContainer,
  createOpenGameAction,
  FlexCreativeAsset,
  FlexCreativeText,
  getRandomCreativeAsset,
} from './utils';

/**
 * Static creative assets for native share invite messages
 */
export const nativeShareInviteAssets = {
  web_share_crying_ja: 'private/creatives/invites/web_share_crying_ja.png',
  web_share_egg_ja: 'private/creatives/invites/web_share_egg_ja.png',
  web_share_sleep_ja: 'private/creatives/invites/web_share_sleep_ja.png',
  web_addingasfriend_A_ja:
    'private/creatives/invites/web_addingasfriend_A_ja.png',
  web_addingasfriend_B_ja:
    'private/creatives/invites/web_addingasfriend_B_ja.png',
  web_addingasfriend_C_ja:
    'private/creatives/invites/web_addingasfriend_C_ja.png',
  web_addingasfriend_D_ja:
    'private/creatives/invites/web_addingasfriend_D_ja.png',
};

/**
 * Static assets for invite share picker messages
 */
export const sharePickerInviteAssets = {
  ...nativeShareInviteAssets,
  invite_mischief_food_1:
    'private/creatives/invites/2025-12-11/OA_invite_mischief_food-1.png',
  invite_mischief_food:
    'private/creatives/invites/2025-12-11/OA_invite_mischief_food.png',
  invite_mystery_crate:
    'private/creatives/invites/2025-12-11/OA_invite_mystery_crate.png',
  invite_mystery_furball:
    'private/creatives/invites/2025-12-11/OA_invite_mystery_furball.png',
  invite_mystery_silhouette:
    'private/creatives/invites/2025-12-11/OA_invite_mystery_silhouette.png',
  invite_pity_abandoned01:
    'private/creatives/invites/2025-12-11/OA_invite_pity_abandoned01.png',
  invite_pity_abandoned02:
    'private/creatives/invites/2025-12-11/OA_invite_pity_abandoned02.png',
  invite_pity_dirty:
    'private/creatives/invites/2025-12-11/OA_invite_pity_dirty.png',
  invite_pity_icecold01:
    'private/creatives/invites/2025-12-11/OA_invite_pity_icecold01.png',
  invite_pity_icecold02:
    'private/creatives/invites/2025-12-11/OA_invite_pity_icecold02.png',
  invite_toilet_cow:
    'private/creatives/invites/2025-12-11/OA_invite_toilet_cow.png',
  invite_toilet_panda:
    'private/creatives/invites/2025-12-11/OA_invite_toilet_panda.png',
  invite_toilet_tiger:
    'private/creatives/invites/2025-12-11/OA_invite_toilet_tiger.png',
  viralmessage_11_jp:
    'private/creatives/invites/2025-12-11/OA_viralmessage_1040x1040_11_jp.png',
  viralmessage_12_jp:
    'private/creatives/invites/2025-12-11/OA_viralmessage_1040x1040_12_jp.png',
  viralmessage_13_jp:
    'private/creatives/invites/2025-12-11/U2U_viralmessage_1040x1040_13_jp.png',
  viralmessage_14_jp:
    'private/creatives/invites/2025-12-11/U2U_viralmessage_1040x1040_14_jp.png',
  viralmessage_15_jp:
    'private/creatives/invites/2025-12-11/U2U_viralmessage_1040x1040_15_jp.png',
  viralmessage_16_jp:
    'private/creatives/invites/2025-12-11/U2U_viralmessage_1040x1040_16_jp.png',
  viralmessage_17_jp:
    'private/creatives/invites/2025-12-11/U2U_viralmessage_1040x1040_17_jp.png',
  viralmessage_18_jp:
    'private/creatives/invites/2025-12-11/U2U_viralmessage_1040x1040_18_jp.png',
  viralmessage_19_jp:
    'private/creatives/invites/2025-12-11/U2U_viralmessage_1040x1040_19_jp.png',
  viralmessage_20_jp:
    'private/creatives/invites/2025-12-11/U2U_viralmessage_1040x1040_20_jp.png',
  viralmessage_21_jp:
    'private/creatives/invites/2025-12-11/U2U_viralmessage_1040x1040_21_jp.png',
  viralmessage_22_jp:
    'private/creatives/invites/2025-12-11/U2U_viralmessage_1040x1040_22_jp.png',
  viralmessage_23_jp:
    'private/creatives/invites/2025-12-11/U2U_viralmessage_1040x1040_23_jp.png',
  viralmessage_24_jp:
    'private/creatives/invites/2025-12-11/U2U_viralmessage_1040x1040_24_jp.png',
  viralmessage_25_jp:
    'private/creatives/invites/2025-12-11/U2U_viralmessage_1040x1040_25_jp.png',
  invite_doghouse_a_jp:
    'private/creatives/invites/2026-02-09/invite_doghouse_a_jp.png',
};

type SharePickerInviteAssetsKey = keyof typeof sharePickerInviteAssets;

/**
 * Get a random Invite feature creative for LINE sharing.
 *
 * @param random Random number generator used to select the creative.
 * @returns Selected invite creative with the active batch prefix.
 */
export function getRandomInviteAsset(random: () => number) {
  return getRandomCreativeAsset(
    {
      prefixId: '2026-07-28',
      best: getBestInvitesCreatives(),
    },
    random,
  );
}

/**
 * Get random Add Friends V2 creative asset for sharing
 */
export function getRandomAddFriendsV2Asset(random: () => number) {
  return getRandomCreativeAsset(
    {
      prefixId: '2025-01-13',
      best: getAddFriendsV2Creatives(),
    },
    random,
  );
}

/**
 * Get Add Friends V2 creatives
 */
function getAddFriendsV2Creatives(): FlexCreativeAsset[] {
  return [
    getInvitesCreativeAsset('web_addingasfriend_A_ja', true),
    getInvitesCreativeAsset('web_addingasfriend_B_ja', true),
    getInvitesCreativeAsset('web_addingasfriend_C_ja', true),
    getInvitesCreativeAsset('web_addingasfriend_D_ja', true),
  ];
}

/**
 * Get the active Invite feature creatives.
 *
 * Five best-performing creatives retained as the production control set.
 *
 * @returns Active Invite feature creative pool.
 */
function getBestInvitesCreatives() {
  return [
    getInvitesCreativeAsset('viralmessage_22_jp', true),
    getInvitesCreativeAsset('invite_mystery_crate', true),
    getInvitesCreativeAsset('viralmessage_21_jp', true),
    getInvitesCreativeAsset('invite_doghouse_a_jp', true),
    getInvitesCreativeAsset('viralmessage_12_jp', true),
  ];
}

/**
 * Get invite creative asset by id
 */
function getInvitesCreativeAsset(
  id: SharePickerInviteAssetsKey,
  cta: boolean,
): FlexCreativeAsset {
  return {
    id,
    noCTA: !cta,
    // Keep `image` as the asset key (not the file path). It will be resolved to a URL
    // via `StateObserver.replicant.getChatbotAssetUrl(...)` where it's used.
    image: id,
  };
}

/**
 * Create an invite Flex message with a call-to-action button.
 *
 * @param args Invite content and optional hero image aspect ratio.
 * @returns LINE Flex message containing the invite creative.
 */
export function inviteMessageWithCTA(args: {
  title: string;
  asset: FlexCreativeAsset;
  creative: FlexCreativeText;
  heroAspectRatio?: string;
  payload: object & { alternativeWebIABBucket: AlternativeOpenWebBuckets };
}) {
  const { asset, creative, heroAspectRatio = '1:1', payload, title } = args;
  const text = creative.text;

  const template = createFlexContainer(title, {
    type: 'bubble',
    hero: {
      type: 'image',
      url: asset.image,
      size: 'full',
      aspectRatio: heroAspectRatio,
      aspectMode: 'cover',
      action: createOpenGameAction(creative.cta, payload),
    },
    body: {
      type: 'box',
      layout: 'vertical',
      contents: [
        {
          type: 'text',
          text: title,
          weight: 'bold',
          size: 'xl',
          wrap: true,
        },
        {
          type: 'box',
          layout: 'vertical',
          margin: 'lg',
          spacing: 'sm',
          contents: [
            {
              type: 'box',
              layout: 'baseline',
              spacing: 'sm',
              contents: [
                {
                  type: 'text',
                  text,
                  color: '#aaaaaa',
                  size: 'sm',
                  wrap: true,
                },
              ],
            },
          ],
        },
      ],
    },
    footer: {
      type: 'box',
      layout: 'vertical',
      spacing: 'sm',
      contents: [
        {
          type: 'button',
          style: 'primary',
          action: createOpenGameAction(creative.cta, payload),
          height: 'sm',
        },
      ],
      flex: 0,
    },
  });

  return template;
}

/**
 * Create invite flex message without CTA part
 */
export function inviteMessageWithoutCTA(args: {
  title: string;
  asset: FlexCreativeAsset;
  creative: FlexCreativeText;
  payload: object & { alternativeWebIABBucket: AlternativeOpenWebBuckets };
}) {
  const { asset, creative, payload, title } = args;

  const template = createFlexContainer(title, {
    type: 'bubble',
    hero: {
      type: 'image',
      url: asset.image,
      size: 'full',
      aspectRatio: '1:1',
      aspectMode: 'cover',
      action: createOpenGameAction(creative.cta, payload),
    },
  });

  return template;
}
